/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bildungskartenummer2Inputs */

const de__field_bildungskartenummer2 = /** @type {(inputs: _Field_Bildungskartenummer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildungskartennummer`)
};

/**

* @param {_Field_Bildungskartenummer2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_bildungskartenummer2 = /** @type {((inputs?: _Field_Bildungskartenummer2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bildungskartenummer2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bildungskartenummer2(inputs)
});
export { _field_bildungskartenummer2 as "_field_bildungsKarteNummer" }